<template>
	<div>
		<h1>Personnaliser l'interface</h1>

		<button class="rounded-full bg-red-400 my-2" @click="resetStyle">
			Reset style
		</button>

		<div :id="'jsoneditor'"></div>

		<!-- * poser une table ici avec des infos bidons pour voir ce que ça donne en temps reel -->
		<edit_tabulator :extern_file="false" ref="example_tabulator" />

		<div
			style="
				width: 100%;
				height: 100px;
				display: inline-block;
				position: relative;
			">
			<pre style="width: 100%; height: 100%" :id="'ace_editor'"></pre>
		</div>

		<notifications position="top center" group="info" />

		<b-button @click="save" class="mt-2">Sauvegarder</b-button>
	</div>
</template>

<script>
	import "../../public/js/query-builder.default.min.css";
	import "../../public/js/query-builder.min.js";
	import "../../public/js/query-builder-fr.js";
	import "../../public/js/ace-builds/src-min-noconflict/ace.js";
	import "../../public/js/ace-builds/src-min-noconflict/ext-language_tools.js";

	import { JSONEditor } from "@json-editor/json-editor";

	import store from "../store";
	import client from "../services/client.js";
	import edit_tabulator from "../components/edit_tabulator.vue";
	var clone = require("clone");

	export default {
		name: "style",
		components: {
			edit_tabulator,
		},
		data: function () {
			return {
				values: {},
				editor: null,
				tabulator_data: [
					{
						id: 1,
						name: "John",
						age: "25",
					},
					{
						id: 2,
						name: "Jane",
						age: "32",
					},
					{
						id: 3,
						name: "Joe",
						age: "47",
					},
				],
				columns: [
					{ title: "Id", field: "id" },
					{ title: "Name", field: "name" },
					{ title: "Age", field: "age" },
				],
			};
		},
		methods: {
			async save() {
				await client.put(null, null, store.state.style);

				this.$notify({
					group: "info",
					title: "Configuration du style sauvegardé",
					type: "success",
				});
			},
			resetStyle() {
				store.commit("removeStyle");
				this.editor.setValue(store.state.style);
			},
			setCode() {
				var ace_editor = ace.edit("ace_editor");
				ace_editor.session.setMode("ace/mode/javascript");
				var theme = "chrome";
				if (this.values && this.values.theme && this.values.theme.code)
					theme = this.values.theme.code;
				ace_editor.setTheme("ace/theme/" + theme);
				ace_editor.setValue(
					"for (var i = 0; i < data.length; i++)\n{\n    if (data == 'hello')\n      console.log('world !');\n}",
					-1
				);
			},
		},
		mounted: async function () {
			var self = this;

			if (store.state.user.rules && !store.state.user.rules.style) {
				this.$router.push({ name: "profile" });
			}

			var schema = {
				title: "Paramètres",
				type: "object",
				format: "categories",
				properties: {
					name: {
						title: "Titre",
						type: "object",
						properties: {
							menu_title: {
								type: "string",
								title: "Nom ou image du menu",
							},
							menu_title_color: {
								type: "string",
								title: "Couleur du titre du menu",
								format: "color",
							},
							menu_title_font: {
								type: "string",
								title: "Police du titre du menu",
								default: "sans",
								enum: [
									"sans",
									"Open Sans",
									"Roboto",
									"Bona Nova",
									"Source Sans Pro",
									"Nanum Gothic",
									"Lato",
									"Comfortaa",
									"Maven Pro",
								],
							},
							menu_title_size: {
								type: "integer",
								title: "Taille du titre du menu",
								format: "range",
								default: 1,
								minimum: 1,
								maximum: 10,
							},
						},
					},
					menu: {
						title: "Menu",
						type: "object",
						basicCategoryTitle: "Background",
						properties: {
							background_color: {
								type: "string",
								title: "Couleur du background du menu",
								format: "color",
							},
							sub_background_color: {
								type: "string",
								title: "Couleur du background des sous menus",
								format: "color",
							},
							select_background_color: {
								type: "string",
								title: "Couleur du background du menu sélectionné",
								format: "color",
							},
							icon_background_color: {
								type: "string",
								title: "Couleur du background des icones",
								format: "color",
							},
							select_color: {
								type: "string",
								title: "Couleur de survol",
								format: "color",
							},
							sub_select_color: {
								type: "string",
								title: "Couleur de survol des sous menus",
								format: "color",
							},
						},
					},
					theme: {
						title: "Thème",
						type: "object",
						properties: {
							background_color: {
								type: "string",
								title: "Couleur du background",
								format: "color",
							},
							text_color: {
								type: "string",
								title: "Couleur du texte",
								format: "color",
							},
							text_color_light: {
								type: "string",
								title: "Couleur du texte sur fond noir",
								format: "color",
							},
							text_font: {
								type: "string",
								title: "Police du texte",
								default: "sans",
								enum: [
									"sans",
									"Open Sans",
									"Roboto",
									"Bona Nova",
									"Source Sans Pro",
									"Nanum Gothic",
									"Lato",
									"Comfortaa",
									"Maven Pro",
								],
							},
							code: {
								type: "string",
								title: "Editeur de code",
								default: "chrome",
								enum: [
									"chrome",
									"clouds",
									"crimson_editor",
									"dawn",
									"dreamweaver",
									"eclipse",
									"github",
									"iplastic",
									"solarized_light",
									"textmate",
									"tomorrow",
									"xcode",
									"kuroir",
									"katzenmilch",
									"sqlserver",
									"ambiance",
									"chaos",
									"clouds_midnight",
									"dracula",
									"cobalt",
									"gruvbox",
									"gob",
									"idle_fingers",
									"kr_theme",
									"merbivore",
									"merbivore_soft",
									"mono_industrial",
									"monokai",
									"nord_dark",
									"one_dark",
									"pastel_on_dark",
									"solarized_dark",
									"terminal",
									"tomorrow_night",
									"tomorrow_night_blue",
									"tomorrow_night_bright",
									"tomorrow_night_eighties",
									"twilight",
									"vibrant_ink",
								],
							},
						},
					},
					tablestyle: {
						title: "Style des tables",
						type: "object",
						properties: {
							header_background_color: {
								type: "string",
								title: "Couleur de fond des entêtes",
								format: "color",
							},
							header_text_color: {
								type: "string",
								title: "Couleur du texte des entêtes",
								format: "color",
							},
							cell_background_color: {
								type: "string",
								title: "Couleur de fond des cellules",
								format: "color",
							},
							cell_text_color: {
								type: "string",
								title: "Couleur du texte des cellules",
								format: "color",
							},
							col_border_thickness: {
								type: "integer",
								title: "Epaisseur de la bordure des colonnes",
								format: "range",
								default: 0,
								minimum: 0,
								maximum: 10,
							},
							row_border_thickness: {
								type: "integer",
								title: "Epaisseur de la bordure des lignes",
								format: "range",
								default: 0,
								minimum: 0,
								maximum: 10,
							},
							border_color: {
								type: "string",
								title: "Couleur de la bordure",
								format: "color",
							},
						},
					},
				},
			};

			const element = document.getElementById("jsoneditor");

			this.editor = new JSONEditor(element, {
				schema: schema,
				keep_oneof_values: false,
				theme: "bootstrap4",
				object_background: "",
				iconlib: "fontawesome5",
				prompt_before_delete: false,
			});

			await new Promise((resolve, reject) => {
				self.editor.on("ready", function () {
					if (resolve) resolve();
				});
			});

			let styleObject = store.state.style;

			if (styleObject.name && typeof styleObject.name === "string") {
				styleObject.name = { menu_title: styleObject.name };
			}
			// console.log("Setting value on editor: ", clone(styleObject));
			this.editor.setValue(styleObject);

			this.editor.on("change", function () {
				self.values = self.editor.getValue();

				if (self.values.theme.text_font === undefined)
					self.values.theme.text_font = "sans";

				self.setCode();
				// * retire les espaces
				// values.theme.text_font = values.theme.text_font.replace(" ", "");
				store.commit("setStyle", self.values);

				// ! bizarrement cet évenement se lance avant que le store ne soit mis à jour, donc on n'arrive pas à changer le stylee
				// self.$emit("styleUpdated", values);
			});

			this.$refs.example_tabulator.set_data(this.tabulator_data);

			this.setCode();
		},
	};
</script>

<style></style>
